var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "479.5 110.54 405.86 110.54 405.86 145.53 435.8 145.53 447 156.73 458.2 145.53 479.5 145.53 479.5 110.54",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.51,126.27a5.23,5.23,0,0,0-10.37-.92,5.29,5.29,0,0,0,.64,3.56h0l0,0c.2.34.45.58.7.94l3,4a1,1,0,0,0,1.51,0l3-3.95a10.7,10.7,0,0,0,.76-1v0h0A5.22,5.22,0,0,0,423.51,126.27Zm-5.22,2.28a2.3,2.3,0,1,1,2.29-2.3A2.3,2.3,0,0,1,418.29,128.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.16,130c0,.14-9.81.26-21.92.26s-21.92-.12-21.92-.26,9.81-.26,21.92-.26S472.16,129.86,472.16,130Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.2,134.72c0,.14-6.69.26-14.94.26s-14.94-.12-14.94-.26,6.69-.27,14.94-.27S458.2,134.57,458.2,134.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431 119.13 432 121.16 434.24 121.49 432.62 123.07 433 125.3 431 124.24 428.99 125.3 429.38 123.07 427.75 121.49 429.99 121.16 431 119.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.48 119.13 441.48 121.16 443.72 121.49 442.1 123.07 442.48 125.3 440.48 124.24 438.47 125.3 438.86 123.07 437.24 121.49 439.48 121.16 440.48 119.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.96 119.13 450.96 121.16 453.2 121.49 451.58 123.07 451.96 125.3 449.96 124.24 447.95 125.3 448.34 123.07 446.72 121.49 448.96 121.16 449.96 119.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.44 119.13 460.44 121.16 462.68 121.49 461.06 123.07 461.44 125.3 459.44 124.24 457.44 125.3 457.82 123.07 456.2 121.49 458.44 121.16 459.44 119.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.92 119.13 469.92 121.16 472.16 121.49 470.54 123.07 470.92 125.3 468.92 124.24 466.92 125.3 467.3 123.07 465.68 121.49 467.92 121.16 468.92 119.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.82 36.82 43.32 36.82 43.32 91.23 89.87 91.23 107.29 108.64 124.7 91.23 157.82 91.23 157.82 36.82",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.76,61.29a8.12,8.12,0,1,0-15.12,4.1h0l0,0c.31.53.7.9,1.1,1.45l4.71,6.25a1.46,1.46,0,0,0,2.34,0L68.45,67a19.41,19.41,0,0,0,1.18-1.57v0h0A8,8,0,0,0,70.76,61.29Zm-8.12,3.53a3.57,3.57,0,1,1,3.57-3.57A3.57,3.57,0,0,1,62.64,64.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.41,67.09c0,.14-15.26.26-34.08.26s-34.09-.12-34.09-.26,15.26-.26,34.09-.26S146.41,67,146.41,67.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.71,74.41c0,.15-10.4.26-23.23.26s-23.24-.11-23.24-.26,10.4-.26,23.24-.26S124.71,74.27,124.71,74.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.41 50.18 83.96 53.34 87.44 53.84 84.92 56.3 85.52 59.77 82.41 58.13 79.29 59.77 79.89 56.3 77.37 53.84 80.85 53.34 82.41 50.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.15 50.18 98.7 53.34 102.19 53.84 99.67 56.3 100.26 59.77 97.15 58.13 94.03 59.77 94.63 56.3 92.11 53.84 95.59 53.34 97.15 50.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.89 50.18 113.45 53.34 116.93 53.84 114.41 56.3 115 59.77 111.89 58.13 108.78 59.77 109.37 56.3 106.85 53.84 110.33 53.34 111.89 50.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.63 50.18 128.19 53.34 131.67 53.84 129.15 56.3 129.75 59.77 126.63 58.13 123.52 59.77 124.11 56.3 121.59 53.84 125.08 53.34 126.63 50.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.38 50.18 142.93 53.34 146.41 53.84 143.9 56.3 144.49 59.77 141.38 58.13 138.26 59.77 138.86 56.3 136.34 53.84 139.82 53.34 141.38 50.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.6,169.93c.6-4.38-5.57-8-10.2-8.35-2.21-.17-4.51.16-6.61-.57-4.53-1.58-6.35-7.44-10.78-9.31-3.31-1.4-7.12-.15-10.33,1.46s-6.38,3.65-10,3.88c-3.12.2-6.5-1-9.23.57-2,1.13-3.1,3.48-5,4.86s-4.22,1.64-6.5,1.76-4.63.15-6.7,1.1-3.79,3.14-3.36,5.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.44,213.19c.61-4.37-5.56-8-10.2-8.34-2.21-.18-4.51.16-6.6-.57-4.54-1.58-6.36-7.45-10.78-9.31-3.32-1.4-7.13-.16-10.34,1.46s-6.38,3.65-10,3.88c-3.11.2-6.5-1-9.23.56-2,1.14-3.1,3.48-5,4.86s-4.23,1.64-6.51,1.77-4.63.14-6.7,1.09-3.78,3.14-3.35,5.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.79,167.12c.44-3.21-4.1-5.86-7.5-6.13-1.63-.13-3.32.12-4.86-.42-3.33-1.16-4.66-5.47-7.92-6.85-2.43-1-5.23-.11-7.59,1.08s-4.69,2.68-7.33,2.85c-2.29.15-4.78-.7-6.79.42-1.49.83-2.27,2.55-3.65,3.57a8.76,8.76,0,0,1-4.78,1.29,13.35,13.35,0,0,0-4.92.81c-1.53.7-2.79,2.31-2.47,3.95Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.39,50.29c.45-3.21-4.09-5.86-7.5-6.13-1.62-.13-3.31.12-4.85-.42-3.33-1.16-4.67-5.47-7.92-6.85-2.44-1-5.24-.11-7.6,1.08s-4.69,2.68-7.32,2.85c-2.29.15-4.78-.7-6.79.42-1.49.83-2.28,2.55-3.65,3.57A8.76,8.76,0,0,1,399,46.1a13.44,13.44,0,0,0-4.93.81c-1.52.7-2.78,2.31-2.46,4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.06,
    y: 208.32,
    width: 83.22,
    height: 263.75,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.68,
    y: 208.32,
    width: 41.61,
    height: 263.03,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.57,
    y: 182.43,
    width: 29.39,
    height: 25.89,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.95,
    y: 182.43,
    width: 7,
    height: 25.89,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "351.13 208.32 351.13 206.81 443.72 206.81 443.72 208.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.49,
    y: 219.61,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,240.3c0,.15-9.32.28-20.81.28s-20.81-.13-20.81-.28,9.32-.29,20.81-.29S399.68,240.14,399.68,240.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.46,
    y: 219.61,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.65,240.3c0,.15-9.32.28-20.81.28s-20.8-.13-20.8-.28,9.31-.29,20.8-.29S441.65,240.14,441.65,240.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.46,
    y: 249.1,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.65,269.79c0,.15-9.32.28-20.81.28s-20.8-.13-20.8-.28,9.31-.29,20.8-.29S441.65,269.63,441.65,269.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.46,
    y: 279.48,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.65,300.17c0,.15-9.32.28-20.81.28s-20.8-.13-20.8-.28,9.31-.29,20.8-.29S441.65,300,441.65,300.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.46,
    y: 309.87,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.65,330.55c0,.16-9.32.28-20.81.28s-20.8-.12-20.8-.28,9.31-.28,20.8-.28S441.65,330.39,441.65,330.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.46,
    y: 339.38,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.65,360.06c0,.16-9.32.28-20.81.28s-20.8-.12-20.8-.28,9.31-.28,20.8-.28S441.65,359.9,441.65,360.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.46,
    y: 369.01,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.46,
    y: 399.03,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.65,389.69c0,.16-9.32.29-20.81.29s-20.8-.13-20.8-.29,9.31-.28,20.8-.28S441.65,389.53,441.65,389.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.49,
    y: 249.55,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,270.24c0,.15-9.32.28-20.81.28s-20.81-.13-20.81-.28,9.32-.29,20.81-.29S399.68,270.08,399.68,270.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.49,
    y: 279.49,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,300.18c0,.16-9.32.28-20.81.28s-20.81-.12-20.81-.28,9.32-.29,20.81-.29S399.68,300,399.68,300.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.49,
    y: 309.44,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,330.12c0,.16-9.32.28-20.81.28s-20.81-.12-20.81-.28,9.32-.28,20.81-.28S399.68,330,399.68,330.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.49,
    y: 339.38,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,360.06c0,.16-9.32.28-20.81.28s-20.81-.12-20.81-.28,9.32-.28,20.81-.28S399.68,359.9,399.68,360.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.49,
    y: 369.32,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.68,390c0,.16-9.32.29-20.81.29s-20.81-.13-20.81-.29,9.32-.28,20.81-.28S399.68,389.84,399.68,390Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.49,
    y: 399.26,
    width: 7.04,
    height: 14.85,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.31 472.29 58.85 472.29 58.31 278.75 180.78 278.75 181.31 472.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.55,
    y: 278.74,
    width: 61.23,
    height: 193.55,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3,
    y: 240.64,
    width: 43.25,
    height: 38.1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.24,
    y: 240.64,
    width: 10.31,
    height: 38.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.11,
    y: 276.52,
    width: 136.25,
    height: 2.22,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.49,
    y: 295.36,
    width: 10.37,
    height: 21.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.55,325.8c0,.23-13.71.42-30.62.42s-30.61-.19-30.61-.42,13.7-.42,30.61-.42S119.55,325.57,119.55,325.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 295.36,
    width: 10.37,
    height: 21.86,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.31,325.8c0,.23-13.71.42-30.61.42s-30.62-.19-30.62-.42,13.71-.42,30.62-.42S181.31,325.57,181.31,325.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 338.76,
    width: 10.37,
    height: 21.86,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.31,369.2c0,.23-13.71.41-30.61.41s-30.62-.18-30.62-.41,13.71-.42,30.62-.42S181.31,369,181.31,369.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 383.47,
    width: 10.37,
    height: 21.86,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.31,413.9c0,.23-13.71.42-30.61.42s-30.62-.19-30.62-.42,13.71-.42,30.62-.42S181.31,413.67,181.31,413.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 428.17,
    width: 10.37,
    height: 21.86,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.31,458.61c0,.23-13.71.41-30.61.41s-30.62-.18-30.62-.41,13.71-.42,30.62-.42S181.31,458.38,181.31,458.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.49,
    y: 339.42,
    width: 10.37,
    height: 21.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.55,369.86c0,.23-13.71.42-30.62.42s-30.61-.19-30.61-.42,13.7-.42,30.61-.42S119.55,369.63,119.55,369.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.49,
    y: 383.48,
    width: 10.37,
    height: 21.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.55,413.92c0,.23-13.71.41-30.62.41s-30.61-.18-30.61-.41,13.7-.42,30.61-.42S119.55,413.69,119.55,413.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.49,
    y: 427.54,
    width: 10.37,
    height: 21.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.55,458c0,.23-13.71.41-30.62.41s-30.61-.18-30.61-.41,13.7-.42,30.61-.42S119.55,457.75,119.55,458Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.31,451.58c.76-3-1.17-5.93-3.35-8.07s-4.77-4.07-5.9-6.9c-1.83-4.6.63-10.55-2.49-14.38-1.84-2.26-5.14-3-6.77-5.42a12.53,12.53,0,0,1-1.47-4.3,43.68,43.68,0,0,0-10.87-20.36,38,38,0,0,0,4.26,19.62c1.27,2.41,2.82,4.76,3.24,7.45.68,4.37-1.75,8.86-.68,13.15,1.23,4.91,6.74,8.19,7,13.24.22,4.27-3.5,8-3.23,12.28A11.62,11.62,0,0,0,393,463c3.3,5.49,8.15,9.27,15.5,9.14l9,.32Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M411.31,451.58c.76-3-1.17-5.93-3.35-8.07s-4.77-4.07-5.9-6.9c-1.83-4.6.63-10.55-2.49-14.38-1.84-2.26-5.14-3-6.77-5.42a12.53,12.53,0,0,1-1.47-4.3,43.68,43.68,0,0,0-10.87-20.36,38,38,0,0,0,4.26,19.62c1.27,2.41,2.82,4.76,3.24,7.45.68,4.37-1.75,8.86-.68,13.15,1.23,4.91,6.74,8.19,7,13.24.22,4.27-3.5,8-3.23,12.28A11.62,11.62,0,0,0,393,463c3.3,5.49,8.15,9.27,15.5,9.14l9,.32Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M419.1,472.46a7.12,7.12,0,0,0,2.48-.06,15.46,15.46,0,0,0,2.92-.73,12.54,12.54,0,0,0,3.61-2,5.09,5.09,0,0,0,1.49-2A9.12,9.12,0,0,0,430,465a26.75,26.75,0,0,1,.21-2.91,8.18,8.18,0,0,1,1.1-2.9c1.06-1.86,2.83-3.63,3.4-6.16s.17-5.18-.25-7.89-.82-5.64.21-8.45,2.94-5.36,3.93-8.53.52-6.66.73-10.06a13.15,13.15,0,0,1,1.17-5c.73-1.6,1.74-3.1,2.53-4.78,1.6-3.39,1.88-7.23,2.32-11,.21-1.9.42-3.81.64-5.75a28.83,28.83,0,0,1,1-5.76,51.54,51.54,0,0,1,2.16-5.57,18.88,18.88,0,0,0,1-2.91,27.32,27.32,0,0,0,.29-3.09,36.09,36.09,0,0,0-.24-6.23c-.24-2.08-.62-4.14-.84-6.22,0-.12,0-.25,0-.36l-.05-.41-.37.18a14,14,0,0,0-4.84,4.09,21.84,21.84,0,0,0-3,5.49c-1.5,3.86-2,7.92-2.8,11.78a32.13,32.13,0,0,1-3.7,10.89c-1,1.6-2.18,3.07-3.23,4.63a12.8,12.8,0,0,0-2.23,5.13c-.53,3.81,1.57,7.15,1.13,10.52a11.71,11.71,0,0,1-1.64,4.67c-.82,1.44-1.78,2.78-2.69,4.12a26.7,26.7,0,0,0-2.42,4.15,13,13,0,0,0-1.1,4.51c-.22,3,.21,5.92,0,8.63a19.8,19.8,0,0,1-2.23,7.4c-1.08,2.22-2.3,4.22-3.31,6.16a30.88,30.88,0,0,0-1.36,2.87,13.51,13.51,0,0,0-.79,2.85,17.76,17.76,0,0,0-.07,5.13,12.9,12.9,0,0,0,2.57,6.55,6.47,6.47,0,0,0,.73.79,4.07,4.07,0,0,0,.59.51l.52.36a11.91,11.91,0,0,1-1.75-1.73,13,13,0,0,1-2.44-6.51,17.75,17.75,0,0,1,.12-5.06,14.2,14.2,0,0,1,.79-2.78c.39-.93.86-1.87,1.38-2.83,1-1.92,2.24-3.92,3.35-6.15a20,20,0,0,0,2.3-7.52c.24-2.78-.18-5.67,0-8.63a12.44,12.44,0,0,1,1.09-4.36,25.54,25.54,0,0,1,2.38-4.07c.91-1.34,1.89-2.67,2.73-4.14a12.18,12.18,0,0,0,1.71-4.86c.44-3.6-1.64-7-1.1-10.5a12.23,12.23,0,0,1,2.16-4.91c1-1.53,2.22-3,3.24-4.64a32.51,32.51,0,0,0,3.78-11.07c.77-3.89,1.31-7.9,2.79-11.69a21.29,21.29,0,0,1,2.9-5.34,13.23,13.23,0,0,1,4.64-3.92l-.42-.23c0,.11,0,.24,0,.36.23,2.11.61,4.17.85,6.23a37.07,37.07,0,0,1,.24,6.13,28.8,28.8,0,0,1-.28,3,17.85,17.85,0,0,1-1,2.81,49.91,49.91,0,0,0-2.17,5.63,27.8,27.8,0,0,0-1,5.85q-.33,2.91-.64,5.76c-.43,3.78-.71,7.56-2.25,10.84-.76,1.63-1.77,3.13-2.52,4.78a13.9,13.9,0,0,0-1.21,5.18c-.19,3.47.26,6.87-.68,10s-2.9,5.61-3.89,8.52-.62,6-.19,8.66.87,5.35.29,7.75-2.23,4.16-3.32,6.08a8.4,8.4,0,0,0-1.11,3,25.42,25.42,0,0,0-.19,2.95,9,9,0,0,1-.39,2.61,4.86,4.86,0,0,1-1.39,1.9,12.43,12.43,0,0,1-3.53,2,15.92,15.92,0,0,1-2.88.79,11.76,11.76,0,0,1-1.83.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.54,366.42s0,.09-.09.27l-.2.81c-.17.71-.39,1.78-.73,3.12s-1.17,2.84-1.86,4.7a64.08,64.08,0,0,0-2.14,6.38c-.69,2.4-1.3,5.07-1.93,7.92a33.15,33.15,0,0,1-2.89,8.79c-.73,1.47-1.56,2.95-2.22,4.56a21.31,21.31,0,0,0-1.3,5.17A104.91,104.91,0,0,1,432.24,419c-1.8,7.38-3.52,14.4-5.09,20.8s-3,12.12-4.26,17-2.15,8.7-2.83,11.45c-.32,1.32-.56,2.36-.74,3.12q-.1.5-.18.81a.9.9,0,0,0,0,.29,1.36,1.36,0,0,0,.1-.27c.06-.22.14-.48.23-.8.21-.75.49-1.79.85-3.1l3-11.4L427.67,440l5.13-20.8a101.14,101.14,0,0,0,1.94-10.94,20.79,20.79,0,0,1,1.25-5c.63-1.58,1.45-3.05,2.19-4.53a33.52,33.52,0,0,0,2.87-8.92c.62-2.87,1.2-5.52,1.86-7.92s1.35-4.53,2-6.38,1.45-3.38,1.78-4.76.49-2.42.63-3.15c.05-.33.1-.6.14-.82A1,1,0,0,0,447.54,366.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.87,471.88c6.33-2.6,9.5-12.59,8-19.26s-4.9-13.07-4.57-19.9c.26-5.25,2.74-10.32,2.27-15.56-.62-7.06-6.51-13.33-5.4-20.34.62-3.93,3.4-7.31,3.8-11.27.49-4.86-2.65-9.23-4.32-13.82-2.56-7-1.66-14.75-1.79-22.23s-1.76-15.69-7.7-20.23c-1.87,6.06-4.12,10.06-4.84,18.53-.26,3,2.39,9.32,1.9,16-.29,4-.68,8-1,12s-.65,7.83.2,11.63c.65,2.91,2,5.66,2.35,8.62.69,5.57-2.1,11.09-1.71,16.69.34,4.74,2.94,9.16,2.9,13.92-.05,6.68-5.28,12.86-4,19.43.62,3.25,2.8,6.12,3.06,9.42.19,2.57-.8,5.11-.66,7.68.23,4.13,7.43,8.38,11.56,8.73",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.86,335.66a1.6,1.6,0,0,0,0,.35c0,.26,0,.61,0,1,0,.91,0,2.25,0,4s.68,3.81,1,6.23.75,5.2,1,8.28.3,6.47.36,10.11.13,7.6,1.35,11.56c.54,2,1.18,4,1.58,6.06a25.71,25.71,0,0,1,.3,6.47,128.16,128.16,0,0,0-.28,13.8c.43,9.44.85,18.43,1.22,26.62s.89,15.52,1.24,21.71l.88,14.64c.12,1.7.21,3,.27,4,0,.43.06.77.09,1a2,2,0,0,0,0,.35,1.35,1.35,0,0,0,0-.35c0-.27,0-.61,0-1,0-.95-.09-2.28-.16-4-.17-3.5-.41-8.49-.7-14.65s-.7-13.55-1.11-21.72-.76-17.17-1.18-26.61a127.38,127.38,0,0,1,.27-13.75,26.36,26.36,0,0,0-.33-6.6c-.41-2.13-1.06-4.13-1.61-6.1-1.22-3.9-1.27-7.8-1.38-11.43s-.18-7-.43-10.13-.62-5.88-1.05-8.3-1-4.48-1.13-6.2-.08-3.07-.12-4c0-.43,0-.78,0-1A1.6,1.6,0,0,0,406.86,335.66Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.11,471.88,207.9,471.8a31.63,31.63,0,0,1-31.61-31.64l.07-364A31.62,31.62,0,0,1,208,44.51l145.21.08a31.63,31.63,0,0,1,31.61,31.64l-.07,364A31.64,31.64,0,0,1,353.11,471.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.12,55.41l-28.25-.13A7,7,0,0,0,319,62.42l0,5.13a7,7,0,0,1-6.89,7.14L257,74.43a7,7,0,0,1-6.83-7.2l0-5.13a7,7,0,0,0-6.83-7.2l-9.93,0-24.73-.11a22.23,22.23,0,0,0-22.33,22.14l-1.51,356.56A22.23,22.23,0,0,0,207,455.76l145.42.67a22.22,22.22,0,0,0,22.33-22.13l1.51-356.57A22.23,22.23,0,0,0,354.12,55.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.41,389.05c-.17,4.31-.33,8.35-.46,11.7h20.89l-2.56-12.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.51,394.42l.18,6.33h82.17c.14-3.55.3-7.5.45-11.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.33 387.86 313.9 400.75 352.41 400.75 351.95 385.29 311.33 387.86",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.49 207.56 301.77 165.34 282.7 163.93 282.7 207.56 294.49 207.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.79 370.99 185.09 379.1 185.03 393.76 206.41 392.4 205.79 370.99",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.7 367.69 204.57 328.37 204.55 328.37 204.55 314.5 185.36 316.53 185.11 375.73 205.69 367.67 205.7 367.69",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.55 283.54 185.51 281.03 185.37 313.39 204.55 311.36 204.55 283.54",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.48 315.08 345.68 326.35 323.19 328.78 324.93 337.69 350.46 335.77 350.08 322.98 352.12 314.51 346.48 315.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.95 339.13 323.88 337.77 319.98 317.76 304.32 319.34 305.95 339.13",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.12 341.2 307.49 357.89 309.92 380.78 310.92 385.79 351.89 383.2 350.52 337.86 306.12 341.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.61,262.41l1.58,2.7-31.6,18.43v43.71l33.35-2.36,64.26-6.49-2.35-28.65-61.4-8,.41-3.1,60.73,7.93-4-48.49-60.1,5.78-.2-2.07L296.43,236l-2.07-25.3H236.54l-50.77,9.24-.25,57.94,19.23,2.54Zm-26.78,60.67s.24-36.05,0-37.39L234.61,272,238,321.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.38 315.3 321.02 317.65 322.79 326.73 343.73 324.47 344.38 315.3",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.7,381.33c-.07,1.89-.14,3.78-.21,5.63l17.38-1.1-.89-4.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.26 207.56 258.32 193.68 281.66 193.68 281.66 163.85 208.68 158.45 208.68 186.45 185.88 191.61 185.78 216.75 236.26 207.56 255.26 207.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,124.58l-.62-2.56,27.87-11L313.07,74.61a8.26,8.26,0,0,1-1,.08l-30.8-.15.84,50.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.19,105.06l0-49.69-20.28-.09A7,7,0,0,0,319,62.42l0,5.13a7.26,7.26,0,0,1-3,5.88l18.14,36.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.42,107.19l-2.35-52.31-5.64,0-22-.1L202,101.53Zm-5-47,.75,42.6-29.3-4.28,6.42-38.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.49,107.35v.44c0,4.08.14,11.43.2,19.29l38.38-1.57-.84-51L257,74.43a7,7,0,0,1-6.83-7.2l0-5.13a7,7,0,0,0-6.83-7.2l-3.24,0,2.35,52.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.9,101.09l9.3-46.33a22.23,22.23,0,0,0-21.83,22.12l-.1,23.09.1-.68Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.55 158.22 186.03 156.77 185.9 188.4 205.55 183.96 205.55 158.22",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.69 102.11 186.27 100.33 186.06 151.55 188.73 151.75 198.69 102.11",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.12 367.09 238.45 325.97 205.61 328.29 206.77 368.58 238.12 367.09",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.16,357.6l46.51,22.28c.56-14.56,1.05-28.17,1-29l1-.06.49-1c.67.33.67.33.32,10.26-.19,5.54-.47,12.91-.75,20.28h16.09L306.45,358l-3.16-38.55-60.77,6.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.17 289.35 357.64 283.93 301.89 289.73 304.24 318.3 352.37 313.44 358.17 289.35",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.66 196.81 260.83 196.81 258.46 207.56 281.66 207.56 281.66 196.81",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.56,200.44l-52.16-3.61-2.12,12.32,2.19,26.74,55-5.29Zm-50.24,8.69,2.8-7.78,45.3,2.87L350,226.46l-49.19,5.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.97 256.33 352.68 232.68 297.64 237.97 299.71 263.14 354.97 256.33",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.47 394.49 185.12 395.84 185.03 394.45 185 400.75 206.65 400.75 206.47 394.49",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.87,93.32l.31.79.07-16.38a22.23,22.23,0,0,0-22.13-22.32l-6.92,0,0,49.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.63,381l-47.48-22.75-1.67-32.59-2,.2-.34,42.2-32.35,1.54,0,.94v0h0l.63,21.76,82.95-5.25C290.47,385.08,290.55,383,290.63,381Zm-81.8-8.72,45.29-3.18,29.47,13.67-74.76,4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.37,148l1.94-11.52c-17-6.08-18.2-23.83-18.15-29.21l-11.11,4.4,16.73,33.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.64 286.62 324.78 284.21 320.22 263.76 299.96 266.26 301.64 286.62",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.57 168.08 308.34 168.07 304.75 167.81 299.87 196.12 351.18 199.67 349.99 187.36 355.04 169.18 351.57 168.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.58,160.48l.54-13.51-17-34.11-26.34,10.43,9,37.19ZM331.11,117l15.56,29.62-2.24,9.23-26.65-1-6.66-28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.31 323.52 356.1 350.07 374.83 349.01 374.89 350.05 356.14 351.11 357.09 382.87 374.8 381.75 374.93 383.83 357.15 384.96 357.63 400.75 374.88 400.75 375.26 312.18 357.61 313.96 355.31 323.52",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.46,108.25l-39.67-5.69L191.87,152l49.76,3.69C241.83,148.06,241.66,124.72,241.46,108.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.69 160.49 312.7 160.49 304.2 125.61 282.13 126.51 282.66 158.7 306.69 160.49",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.89,426.13l0,7.31c0,.22,0,.44,0,.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.65,155.74l39,2.89-.52-32.08-38.39,1.57C242.78,139,242.81,150.54,242.65,155.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.27 259.44 321.26 263.64 325.83 284.1 357.34 280.82 355.27 259.44",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.49,135.47l2.18-12.93,9.39.73.12-27.84-29,11.47C346.63,126.48,358.93,133.37,364.49,135.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.34 185.44 354.52 197.65 375.74 199.12 375.84 173.97 358.08 168.36 353.34 185.44",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.44,289.72l-5.57,23.17,17.39-1.76.11-24.29c-5.34-1.41-10-2.55-12.51-3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.69 160.88 375.87 168.51 375.93 154.77 352.19 148.63 351.69 160.88",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.56,280.62c1.95.3,5.64,1.08,12.82,3l.22-53.11-17.73,1.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.67 230.11 375.61 228.38 375.72 202.25 354.83 200.8 357.67 230.11",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.49,136.13c3.41,1,6.57,1.83,9.5,2.42l.06-13.19-7.64-.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.4,148.56l11.54,3,.05-11.92q-4.49-.88-9.67-2.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.93,383.83l-.13-2.08-17.71,1.12-.95-31.76,18.75-1.06-.05-1-18.74,1.06-.79-26.54,2.3-9.57,17.65-1.78v-1.05l-17.39,1.76,5.57-23.17-.58-5.91c2.51.48,7.17,1.62,12.51,3v-3.25c-7.18-1.89-10.87-2.67-12.82-3l-4.69-48.44,17.73-1.7v-2.1l-17.94,1.73-2.84-29.31,20.89,1.45,0-3.14-21.22-1.46-1.18-12.21,4.74-17.08L375.84,174l0-5.46-24.18-7.63.49-12.25,23.74,6.14,0-3.23-11.54-3,1.92-11.4q5.19,1.58,9.67,2.46v-1.07c-2.93-.59-6.09-1.39-9.5-2.42l1.92-11.36,7.64.59v-2.09l-9.39-.73-2.18,12.93c-5.56-2.1-17.86-9-17.27-28.57l29-11.47V94.11l-.31-.79-28.64,11.33,0-49.27h-1.05l0,49.69-12.07,4.78L316,73.43a6.67,6.67,0,0,1-2.91,1.18L331.2,111l-27.87,11,.62,2.56-21.84.89-.84-50.93h-1l.84,51-38.38,1.57c-.06-7.86-.15-15.21-.2-19.29v-.44h0l-2.35-52.46h-1.05l2.35,52.31L202,101.53l9.39-46.78H208.7l-.5,0-9.3,46.33-12.53-1.8-.1.68v.36l12.42,1.78-10,49.64-2.68-.2,0,5.22,19.52,1.45V184L185.9,188.4v3.21l22.79-5.16v-28l73,5.41v29.82H258.32l-3.06,13.89h-19l-50.48,9.18v3.18l50.77-9.24h57.82l2.07,25.3-60.13,5.79.2,2.07,60.1-5.78,4,48.49-60.73-7.93-.41,3.1,61.4,8,2.35,28.65-64.26,6.49-33.35,2.36V283.54l31.6-18.43-1.58-2.7-30.86,18-19.23-2.54V281l19,2.51v27.82l-19.18,2v3.14l19.19-2v13.87h0l1.13,39.32v0l-20.58,8.06,0,3.36,20.7-8.1.62,21.42L185,393.76v.69l.09,1.39,21.35-1.35.18,6.26h1l-.18-6.33,82.8-5.23c-.15,4.06-.31,8-.45,11.56H292c.13-3.35.29-7.39.46-11.7l17.87-1.13,2.56,12.83h1.06l-2.57-12.89L352,385.29l.46,15.46h5.22M292.49,387c.07-1.85.14-3.74.21-5.63l16.28.05.89,4.48Zm18.43-1.17-1-5-2.43-22.89-1.37-16.69,44.4-3.34,1.37,45.34ZM321,317.65l23.36-2.35-.65,9.17-20.94,2.26Zm-1,.11,3.9,20L306,339.13l-1.63-19.79Zm30.48,18-25.53,1.92-1.74-8.91,22.49-2.43.8-11.27,5.63-.56-2,8.46Zm-30.24-72,4.56,20.45-23.14,2.4L300,266.26Zm5.61,20.34-4.57-20.46,34-4.19,2.07,21.37Zm23.42-86.82-51.31-3.55,4.88-28.31,3.59.27h43.23l3.47,1.09L348.06,185Zm-3.09-90c-.05,5.38,1.13,23.13,18.15,29.21L362.37,148l-10.59-2.74-16.73-33.59Zm-14,5.55,17,34.11-.54,13.51H314.84l-9-37.19ZM304.2,125.61l8.5,34.87h-6l-24-1.78-.53-32.19Zm-23.11.94.52,32.08-39-2.89c.16-5.2.13-16.77,0-27.62Zm-79.3-24,39.67,5.69c.2,16.47.37,39.81.17,47.42L191.87,152Zm100,62.79-7.28,42.22H282.7V163.93Zm-40.94,31.46h20.83v10.76h-23.2Zm34.45,12.34,2.12-12.32,52.16,3.61,2.92,30.16-55,5.29Zm57.4,23.53L355,256.33l-55.26,6.81L297.64,238Zm-50.79,57.05,55.75-5.8.53,5.42-5.8,24.09-48.13,4.86ZM306.45,358l2.38,22.35H292.74c.28-7.37.56-14.74.75-20.28.35-9.93.35-9.93-.32-10.26l-.49,1-1,.06c.05.87-.44,14.48-1,29L244.16,357.6l-1.64-32,60.77-6.14Zm-68-32-.33,41.12-31.35,1.49-1.16-40.29Zm-31.63,44.61h0v0l0-.94,32.35-1.54.34-42.2,2-.2,1.67,32.59L290.63,381c-.08,2-.16,4.06-.23,6.07l-82.95,5.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.12 369.12 208.83 372.3 208.83 386.84 283.58 382.79 254.12 369.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.42 204.22 302.12 201.35 299.32 209.13 300.85 232.3 350.04 226.46 347.42 204.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,351.53l-.11,74.6v8A22.21,22.21,0,0,0,207,455.76l145.42.67a22.22,22.22,0,0,0,22.33-22.13l.14-82.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.04 105.51 237.29 62.9 215.16 62.9 208.74 101.22 238.04 105.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.43 155.87 346.68 146.63 331.11 117.01 311.12 126.84 317.79 154.86 344.43 155.87",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.83,285.69c.24,1.34,0,37.39,0,37.39L238,321.24,234.61,272Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.95 314.96 304.41 292.62 354.36 286.2 354.36 290.05 348.32 310.59 305.95 314.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,371.87l-.63-14.57L308,359.43a6.75,6.75,0,0,1-3.31-.7l-62.28-31.46a4.52,4.52,0,0,1-2.47-3.79l-8.47-164.39a2.69,2.69,0,0,1,.82-2.11,2.78,2.78,0,0,1,2.12-.78l26.69,2V129h3.13v29.59a2.76,2.76,0,0,1-2.95,2.74l-26.67-2,8.45,164a1.4,1.4,0,0,0,.76,1.16l62.28,31.46a3.54,3.54,0,0,0,1.75.37l44.27-2.15a2.77,2.77,0,0,1,2.9,2.64l.64,14.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.75,185.37a24,24,0,1,0-44.63,12.11h0l.07.09c.92,1.54,2.07,2.65,3.23,4.28l13.92,18.43a4.32,4.32,0,0,0,6.91,0l13.68-18.13a51.62,51.62,0,0,0,3.48-4.61l.05-.06h0A23.84,23.84,0,0,0,348.75,185.37Zm-24,10.43a10.55,10.55,0,1,1,10.55-10.55A10.54,10.54,0,0,1,324.78,195.8Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.7,383.18a10.87,10.87,0,1,0-20.25,5.49h0l0,0c.42.71.94,1.21,1.47,2l6.31,8.36a2,2,0,0,0,3.14,0l6.2-8.23a23.24,23.24,0,0,0,1.58-2.09l0,0h0A10.78,10.78,0,0,0,219.7,383.18Zm-10.87,4.73a4.79,4.79,0,1,1,4.78-4.78A4.78,4.78,0,0,1,208.83,387.91Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.91,391c0,.14-27.13.26-60.59.26s-60.6-.12-60.6-.26,27.13-.26,60.6-.26S350.91,390.8,350.91,391Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,400.75c0,.15-13.93.26-31.11.26s-31.12-.11-31.12-.26,13.93-.26,31.12-.26S292,400.61,292,400.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.3 368.3 237.38 372.53 242.04 373.21 238.67 376.49 239.47 381.14 235.3 378.95 231.13 381.14 231.92 376.49 228.55 373.21 233.21 372.53 235.3 368.3",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.04 368.3 257.13 372.53 261.79 373.21 258.41 376.49 259.21 381.14 255.04 378.95 250.87 381.14 251.67 376.49 248.29 373.21 252.96 372.53 255.04 368.3",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.78 368.3 276.87 372.53 281.53 373.21 278.16 376.49 278.95 381.14 274.78 378.95 270.61 381.14 271.41 376.49 268.04 373.21 272.7 372.53 274.78 368.3",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.53 368.3 296.61 372.53 301.27 373.21 297.9 376.49 298.7 381.14 294.53 378.95 290.36 381.14 291.15 376.49 287.78 373.21 292.44 372.53 294.53 368.3",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.27 368.3 316.36 372.53 321.02 373.21 317.65 376.49 318.44 381.14 314.27 378.95 310.1 381.14 310.9 376.49 307.52 373.21 312.19 372.53 314.27 368.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.64,419.69c0,.15-7.58.26-16.93.26s-16.93-.11-16.93-.26,7.58-.26,16.93-.26S269.64,419.55,269.64,419.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.64,428.22c0,.14-27.06.26-60.43.26s-60.43-.12-60.43-.26,27-.27,60.43-.27S356.64,428.07,356.64,428.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.93,
    cy: 423.79,
    r: 10.32,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.14,423.5a3.23,3.23,0,0,0,2-3,3,3,0,1,0-6.05-.1,3.23,3.23,0,0,0,1.9,3c-4.67.65-4.51,5.71-4.51,5.71l11,.17S219.74,424.25,215.14,423.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.6,445.73h0a.52.52,0,0,1-.36-.16l-5-5.22a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l4.65,4.84,4.56-4.75a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71L281,445.57A.48.48,0,0,1,280.6,445.73Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.87,113c.84-.19,1.87-.23,2.33-1s-.11-1.9-.87-2.51-1.7-1.07-2.14-1.94a3.33,3.33,0,0,1,.47-3.2,7,7,0,0,1,10.74-1.31l2.41-.21a33.72,33.72,0,0,1-.06,8.46,11.32,11.32,0,0,1-4.07,7.21,5.46,5.46,0,0,1-3.31,1.18,3.24,3.24,0,0,1-2.89-1.78,2.33,2.33,0,0,1,1.08-3,11.09,11.09,0,0,1-3.88.43,1.49,1.49,0,0,1-1.14-.55C104.09,114,105,113.19,105.87,113Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.69,115.56A67.86,67.86,0,0,1,116,104.14a24.24,24.24,0,0,1,.27-11.88c.18-.58,1.76-4.5,2.37-4.47.43,0-.48,3.63-.24,4a20.5,20.5,0,0,1,3,11.85,54,54,0,0,1-1.72,11.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,155.13c-6.21.22-13.09-11.3-13.45-17.49l-2.15-37.31c-.9-10,4.18-18.86,14.2-19.48h.93a18,18,0,0,1,18,16.45c.73,8.67,1.42,18.27,1.38,22.92-.08,9.64-9.72,11.17-9.72,11.17s.08,2.24.21,5.06c.29,6.35-.15,21-6.5,21.2Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.17,131.38a23.28,23.28,0,0,1-12.56-3.66s3.09,7,12.7,6.1Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.41,105.26a1.37,1.37,0,0,1-1.32,1.39,1.32,1.32,0,0,1-1.42-1.24A1.37,1.37,0,0,1,147,104,1.31,1.31,0,0,1,148.41,105.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46,101.3c-.17.18-1.21-.59-2.69-.58s-2.57.75-2.73.57.1-.4.57-.75a3.81,3.81,0,0,1,2.18-.68,3.62,3.62,0,0,1,2.14.68C149.39,100.89,149.55,101.22,149.46,101.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,105.77a1.4,1.4,0,0,1-1.33,1.4,1.32,1.32,0,0,1-1.42-1.24,1.36,1.36,0,0,1,1.32-1.39A1.32,1.32,0,0,1,135,105.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,102c-.17.18-1.22-.59-2.7-.58s-2.56.75-2.72.57.09-.4.56-.75a3.76,3.76,0,0,1,2.18-.68,3.65,3.65,0,0,1,2.15.68C134.89,101.54,135,101.87,135,102Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,113.31a9.15,9.15,0,0,1,2.4-.44c.38,0,.74-.12.8-.38a1.94,1.94,0,0,0-.25-1.12c-.36-.91-.74-1.87-1.13-2.88-1.57-4.09-2.71-7.46-2.54-7.52s1.57,3.21,3.14,7.3c.37,1,.74,2,1.08,2.9a2.21,2.21,0,0,1,.2,1.48.94.94,0,0,1-.62.55,2.71,2.71,0,0,1-.64.1A10.23,10.23,0,0,1,140.31,113.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,114.35c.24,0,.24,1.59,1.62,2.73s3.1,1,3.11,1.17-.38.32-1.11.34a4,4,0,0,1-2.59-.89,3.51,3.51,0,0,1-1.26-2.29C135.67,114.74,135.85,114.34,136,114.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.86,95.94c-.15.4-1.63.21-3.36.43s-3.15.69-3.38.33c-.1-.17.14-.55.71-.94a5.63,5.63,0,0,1,2.5-.88,5.55,5.55,0,0,1,2.63.3C134.6,95.43,134.92,95.75,134.86,95.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.83,96.38c-.26.33-1.28,0-2.5,0s-2.27.23-2.51-.12c-.1-.17.06-.51.51-.83a3.48,3.48,0,0,1,2-.56,3.54,3.54,0,0,1,2,.67C148.8,95.87,149,96.21,148.83,96.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.23,107.46c-.16-.07-6.63-1.93-6.39,4.66s6.8,5,6.8,4.8S119.23,107.46,119.23,107.46Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.54,114.5s-.11.08-.3.18a1.2,1.2,0,0,1-.86,0,2.86,2.86,0,0,1-1.4-2.51,3.7,3.7,0,0,1,.26-1.65,1.3,1.3,0,0,1,.83-.91.59.59,0,0,1,.69.29c.1.18.06.31.09.32s.14-.11.08-.38a.74.74,0,0,0-.28-.41.85.85,0,0,0-.64-.14,1.63,1.63,0,0,0-1.16,1.06,4,4,0,0,0-.33,1.85,3,3,0,0,0,1.77,2.79,1.27,1.27,0,0,0,1-.21C117.53,114.66,117.56,114.51,117.54,114.5Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.77,86.57c1-.64-2.32-3.95-5-5-4-1.62-10.13-2.46-13.73-1.26-4.34,1.44-7.9,3.79-9.93,7.88a26,26,0,0,0-2.32,13.36,7.84,7.84,0,0,0,1.11,4c1,1.42,2.79,2.25,2.8,4.27a2.75,2.75,0,0,0,.77,2c1.26,1.22,2.68,0,3.31-1.28,1.33-2.65,1.36-5.73,1.35-8.69a19.26,19.26,0,0,0-.69-6.25c-.37-1.08-.93-2.1-1.24-3.2a3.94,3.94,0,0,1,.32-3.31,3.84,3.84,0,0,1,.51-.56,6.87,6.87,0,0,1,6.75-1.6c3.77,1.15,10.19,2.83,11.79,1.5a10.05,10.05,0,0,0,2.81-3.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.35,79.38a14.46,14.46,0,0,1,11.15.12,7.56,7.56,0,0,1,4.17,4.19c.63,1.93-.09,4.37-1.94,5.21l-.12.09c-2.77,1.07-4.61.77-7.46-.07-2.39-.71-4.55-2.07-7-2.77a13.34,13.34,0,0,0-7.84.11A21.93,21.93,0,0,1,128.35,79.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07,85.27a8.06,8.06,0,0,1,3.16-.82,9.35,9.35,0,0,1,3.49.6A26.93,26.93,0,0,1,130.67,87a31.16,31.16,0,0,0,4,2,9.85,9.85,0,0,0,3.62.71,6.59,6.59,0,0,0,2.45-.45,2.29,2.29,0,0,0,.79-.46,8.7,8.7,0,0,1-3.23.55,10.15,10.15,0,0,1-3.46-.79,34,34,0,0,1-3.93-2,23.54,23.54,0,0,0-4-1.93,9.38,9.38,0,0,0-3.66-.52,6.11,6.11,0,0,0-2.4.65A2.08,2.08,0,0,0,120.07,85.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.75,83a8.88,8.88,0,0,1,2.94-.57,9.66,9.66,0,0,1,3.17.6,18.54,18.54,0,0,1,3.56,1.83c1.21.76,2.35,1.54,3.45,2.16a15.24,15.24,0,0,0,3,1.38,8.55,8.55,0,0,0,2.23.4,2.27,2.27,0,0,0,.83-.06,18.59,18.59,0,0,1-2.94-.68,17.12,17.12,0,0,1-2.94-1.44c-1.06-.64-2.18-1.42-3.41-2.19A17.5,17.5,0,0,0,129,82.58a9.38,9.38,0,0,0-3.34-.52,6.37,6.37,0,0,0-2.22.49A2,2,0,0,0,122.75,83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.07,80.23s.34.47.94,1.13a12.93,12.93,0,0,1,2.05,2.79,6.46,6.46,0,0,1,.75,3.29c-.05.88-.28,1.4-.21,1.43s.41-.45.57-1.39a5.89,5.89,0,0,0-.66-3.56,10.23,10.23,0,0,0-2.24-2.81C138.59,80.5,138.12,80.18,138.07,80.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.79,83.18a12.3,12.3,0,0,1,.08,3A11.78,11.78,0,0,1,141.73,89s.35-.15.72-.62a5.06,5.06,0,0,0,.92-2.11,4.83,4.83,0,0,0-.13-2.3C143.06,83.45,142.84,83.15,142.79,83.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.59,101.79a5.65,5.65,0,0,0,.08,2.82,4.38,4.38,0,0,0,1.22,2.55c.12-.08-.42-1.18-.72-2.66A13,13,0,0,0,115.59,101.79Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.83,406.28l1,21.65s-21.68,8.23-21.9,12.24l42-.33-.09-33.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.76,426A1.72,1.72,0,0,1,124,428a1.64,1.64,0,0,1-1.92,1.21,1.81,1.81,0,0,1-1.26-2.07,1.71,1.71,0,0,1,2.14-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.91,439.84l-.14-3.4L89.53,438s-1.87.83-1.65,2.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.1,427.72c0,.2,1,.29,2.05.94s1.56,1.51,1.74,1.43-.12-1.27-1.37-2S109.05,427.53,109.1,427.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.7,429.57c0,.2.85.55,1.55,1.41s.91,1.78,1.12,1.77.32-1.18-.57-2.23S104.71,429.38,104.7,429.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.24,434.87c.19,0,.46-1-.07-2.11s-1.5-1.55-1.59-1.38.52.76.94,1.69S102,434.85,102.24,434.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,422.76c.09.19,1-.1,2.19,0s2.06.43,2.17.25-.77-.9-2.14-1S109.33,422.6,109.43,422.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.31,406.28l-.94,21.65s21.68,8.23,21.89,12.24l-42-.33.1-33.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.39,426a1.72,1.72,0,0,0-1.21,1.95,1.66,1.66,0,0,0,1.93,1.21,1.81,1.81,0,0,0,1.26-2.07,1.71,1.71,0,0,0-2.14-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.23,439.84l.15-3.4L191.62,438s1.86.83,1.64,2.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.05,427.72c0,.2-1,.29-2.05.94s-1.56,1.51-1.75,1.43.13-1.27,1.37-2S172.1,427.53,172.05,427.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.45,429.57c0,.2-.85.55-1.55,1.41s-.92,1.78-1.12,1.77-.33-1.18.57-2.23S176.44,429.38,176.45,429.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.91,434.87c-.19,0-.47-1,.07-2.11s1.5-1.55,1.58-1.38-.51.76-.94,1.69S179.11,434.85,178.91,434.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.72,422.76c-.09.19-1-.1-2.19,0s-2.07.43-2.17.25.77-.9,2.14-1S171.82,422.6,171.72,422.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.86,243.15c0,1.32,8.51,179.42,8.51,179.42l22.1.21,7.18-151.47s9.24,79.59,9.24,81.35,2.62,71,2.62,71h23.32V258.56l-15-24.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.93,423.64a1.71,1.71,0,0,1,0-.4c0-.29,0-.68,0-1.18,0-1.07,0-2.59,0-4.54-.06-3.95-.18-9.66-.38-16.71-.43-14.11-1.23-33.58-2.22-55.09s-2-41-2.68-55.09c-.34-7-.62-12.72-.81-16.69-.08-1.95-.14-3.48-.19-4.54,0-.5,0-.89,0-1.18a2.12,2.12,0,0,1,0-.41,1.87,1.87,0,0,1,.05.4c0,.29,0,.68.09,1.18.06,1.07.16,2.59.28,4.54.23,4,.56,9.66,1,16.68.79,14.09,1.82,33.56,2.83,55.08s1.74,41,2.07,55.11c.16,7.06.22,12.77.22,16.71,0,2,0,3.48,0,4.55,0,.5,0,.89,0,1.18A2,2,0,0,1,160.93,423.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.21,267.83c.14,0,.13,34.66,0,77.42s-.4,77.43-.54,77.43-.13-34.66,0-77.43S120.07,267.82,120.21,267.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.42,262.8a4.5,4.5,0,0,1-1,.47c-.69.26-1.7.63-2.94,1.07l-.23.08,0-.25c-.14-2.19-.31-5.12-.46-8.33-.17-3.48-.29-6.63-.35-8.91,0-1.14,0-2.07,0-2.7a3.61,3.61,0,0,1,0-1,4.59,4.59,0,0,1,.15,1c.06.63.13,1.55.21,2.69.15,2.28.33,5.43.49,8.91.16,3.21.27,6.14.33,8.33l-.25-.17c1.26-.4,2.28-.71,3-.92A4.51,4.51,0,0,1,139.42,262.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,243.87s.08-.14.34-.24a1.56,1.56,0,0,1,1.15.11,1.5,1.5,0,0,1,.87,1.5,1.81,1.81,0,0,1-1.38,1.61,1.87,1.87,0,0,1-1.92-.92,1.76,1.76,0,0,1,.88-2.48c.26-.1.41-.08.42,0s-.59.21-.95,1a1.33,1.33,0,0,0,.06,1.32,1.43,1.43,0,0,0,1.41.65,1.36,1.36,0,0,0,1-1.15,1.15,1.15,0,0,0-.57-1.13A2,2,0,0,0,137.45,243.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.37,245.74c-.14,0-.33-.78-.43-1.76s-.07-1.8.07-1.82.33.78.44,1.76S149.52,245.72,149.37,245.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.18,245.56c-.15,0-.26-.84-.27-1.88s.11-1.88.25-1.88.26.84.26,1.88S151.32,245.56,151.18,245.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.86,246.81a9.15,9.15,0,0,1-.47-4.28,9.15,9.15,0,0,1,.47,4.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,247a3.48,3.48,0,0,1-.63-2.22,3.41,3.41,0,0,1,.45-2.26,10.84,10.84,0,0,1,.06,2.24A10.36,10.36,0,0,1,122,247Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.51,447.07l7.31,6.69A15,15,0,0,0,107,457.71h66.82a15,15,0,0,0,10.15-3.95l7.31-6.69Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 439.39,
    width: 106.72,
    height: 7.91,
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.03,
    y: 415.53,
    width: 15.7,
    height: 57.6,
    rx: 6.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.49,472.36c-.14,0-.49-12.35-.77-27.6s-.39-27.6-.24-27.6.48,12.35.76,27.59S78.63,472.36,78.49,472.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,468.06a41.16,41.16,0,0,1-4-5,38.47,38.47,0,0,1-3.62-5.34,41.16,41.16,0,0,1,4,5A39.59,39.59,0,0,1,78,468.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.43,461.38a47.46,47.46,0,0,1-4.17-5.48,44.25,44.25,0,0,1-3.75-5.77,47.46,47.46,0,0,1,4.17,5.48A45,45,0,0,1,78.43,461.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.48,452.84A46.33,46.33,0,0,1,73.54,447,47.94,47.94,0,0,1,70,440.9,47.33,47.33,0,0,1,74,446.73,48.83,48.83,0,0,1,77.48,452.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.48,445.88a8.18,8.18,0,0,1-1.21-1.77c-.69-1.13-1.61-2.71-2.6-4.46s-1.86-3.36-2.46-4.53a8,8,0,0,1-.88-1.94A10.16,10.16,0,0,1,71.54,435c.69,1.13,1.61,2.7,2.59,4.45s1.85,3.34,2.46,4.51A9.55,9.55,0,0,1,77.48,445.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.33,438.23a28.39,28.39,0,0,1-3.91-5.85c-1-1.7-1.75-3.26-2.3-4.4a7.78,7.78,0,0,1-.79-1.91,61.81,61.81,0,0,1,3.54,6.06c.95,1.68,1.82,3.2,2.47,4.29A9.82,9.82,0,0,1,77.33,438.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.42,430.29a32.27,32.27,0,0,1-2.72-4.92,30.84,30.84,0,0,1-2.27-5.15,30.28,30.28,0,0,1,2.73,4.92A29.88,29.88,0,0,1,76.42,430.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.06,456.77a40.59,40.59,0,0,1-2.83,5.77,39.75,39.75,0,0,1-3.29,5.52,41.37,41.37,0,0,1,2.84-5.77A39.91,39.91,0,0,1,85.06,456.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.88,448.48a25.43,25.43,0,0,1-2.57,6.16c-.85,1.63-1.66,3.08-2.28,4.12a7,7,0,0,1-1.09,1.63,50.52,50.52,0,0,1,2.91-6c.85-1.63,1.59-3.11,2.12-4.19A8.54,8.54,0,0,1,84.88,448.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.06,437.44a56,56,0,0,1-2.8,7A55.86,55.86,0,0,1,79,451.21a55.27,55.27,0,0,1,2.81-7A54.14,54.14,0,0,1,85.06,437.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.22,431.2a36.09,36.09,0,0,1-2,5.63,34.82,34.82,0,0,1-2.48,5.44,33.75,33.75,0,0,1,2-5.63A34.82,34.82,0,0,1,84.22,431.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.51,423.8a20.14,20.14,0,0,1-1.71,5.68,20.11,20.11,0,0,1-2.86,5.21c-.13-.08,1.13-2.41,2.38-5.41S83.36,423.76,83.51,423.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,415,87.5,442.5V419.63a4.28,4.28,0,0,0-4.11-4.33Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.88,
    y: 428.42,
    width: 2.62,
    height: 21.41,
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.11,
    y: 415.51,
    width: 15.7,
    height: 57.59,
    rx: 6.97,
    transform: "translate(409.93 888.62) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.36,472.34c-.15,0,0-12.36.25-27.6s.62-27.61.76-27.6,0,12.36-.25,27.61S204.5,472.35,204.36,472.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.86,468a80.75,80.75,0,0,1,7.66-10.38A40.76,40.76,0,0,1,208.9,463,40.63,40.63,0,0,1,204.86,468Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.41,461.36a46.39,46.39,0,0,1,3.75-5.77,45.57,45.57,0,0,1,4.18-5.48,46.88,46.88,0,0,1-3.76,5.78A45.28,45.28,0,0,1,204.41,461.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.37,452.82a49.46,49.46,0,0,1,3.5-6.11,47.63,47.63,0,0,1,3.94-5.83,95,95,0,0,1-7.44,11.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.37,445.86a9,9,0,0,1,.89-1.94c.6-1.17,1.47-2.77,2.45-4.52s1.91-3.32,2.59-4.45a8.57,8.57,0,0,1,1.22-1.78,9.54,9.54,0,0,1-.88,1.93c-.61,1.17-1.48,2.77-2.47,4.53s-1.91,3.33-2.6,4.46A8.41,8.41,0,0,1,205.37,445.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.52,438.21a10.21,10.21,0,0,1,1-1.81c.64-1.09,1.51-2.61,2.46-4.29a60.61,60.61,0,0,1,3.55-6.06,8.32,8.32,0,0,1-.79,1.91c-.56,1.14-1.36,2.71-2.31,4.4A29.09,29.09,0,0,1,205.52,438.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.42,430.27a30.84,30.84,0,0,1,2.27-5.15,31.29,31.29,0,0,1,2.72-4.92,30.26,30.26,0,0,1-2.26,5.15A30.83,30.83,0,0,1,206.42,430.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.78,456.75A78.88,78.88,0,0,1,203.9,468a38.46,38.46,0,0,1-3.28-5.52A41.37,41.37,0,0,1,197.78,456.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,448.46a8.83,8.83,0,0,1,.92,1.73c.52,1.08,1.27,2.56,2.11,4.19a48.69,48.69,0,0,1,2.91,6,7.51,7.51,0,0,1-1.09-1.63c-.61-1-1.43-2.49-2.28-4.12A25.93,25.93,0,0,1,198,448.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.78,437.42a55,55,0,0,1,3.28,6.78,54.24,54.24,0,0,1,2.8,7,55.85,55.85,0,0,1-3.27-6.78A55.27,55.27,0,0,1,197.78,437.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.62,431.18a33.25,33.25,0,0,1,2.48,5.44,35.58,35.58,0,0,1,2,5.63,34.82,34.82,0,0,1-2.48-5.44A35.19,35.19,0,0,1,198.62,431.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.34,423.78c.14,0,.92,2.49,2.18,5.48s2.51,5.33,2.38,5.41a28.57,28.57,0,0,1-4.56-10.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.74,414.39l-15.52,27V419a4.24,4.24,0,0,1,4.11-4.24Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.22,
    y: 427.28,
    width: 2.9,
    height: 20.02,
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.14,447.36c0,.14-25.24.26-56.36.26s-56.37-.12-56.37-.26,25.23-.26,56.37-.26S197.14,447.22,197.14,447.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.62,283.81s-.68-10.89-9.61-9.76-9.17,9.16-9.17,9.16L72,282.53s1.42-11.38,14-11.06,12.33,13.11,12.33,13.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.62,283.81s-.68-10.89-9.61-9.76-9.17,9.16-9.17,9.16L72,282.53s1.42-11.38,14-11.06,12.33,13.11,12.33,13.11Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "52.66 280.65 50.7 332.07 118.71 333.32 119.87 282.51 52.66 280.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.87,282.51s0,.08-.12.21l-.41.57c-.4.54-.94,1.26-1.61,2.18-1.42,1.88-3.44,4.62-6.08,7.91a68.82,68.82,0,0,1-10.26,10.67A35.74,35.74,0,0,1,94,308.69,24.61,24.61,0,0,1,84.81,311a22,22,0,0,1-9.25-1.73,29.19,29.19,0,0,1-7.48-4.59,42.61,42.61,0,0,1-9.31-11.49,99.37,99.37,0,0,1-4.5-8.91l-1.09-2.48-.27-.65c-.06-.15-.08-.23-.07-.23a1.72,1.72,0,0,1,.12.21l.32.63,1.18,2.44c1,2.11,2.49,5.19,4.63,8.8a43.07,43.07,0,0,0,9.3,11.3,29,29,0,0,0,7.37,4.49,21.65,21.65,0,0,0,9,1.68,23.88,23.88,0,0,0,8.94-2.22,35.34,35.34,0,0,0,7.36-4.54,70.42,70.42,0,0,0,10.26-10.53c2.68-3.25,4.75-5.95,6.21-7.8l1.69-2.11.46-.55A1.45,1.45,0,0,1,119.87,282.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,333.15c-.15,0,1.92-11.1,4.61-24.73s5-24.66,5.13-24.63-1.92,11.1-4.61,24.73S109.54,333.18,109.4,333.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.58,282.9a2.52,2.52,0,0,1,0,.51c0,.4,0,.89,0,1.48-.05,1.28-.17,3.12-.33,5.41-.33,4.56-.91,10.86-1.62,17.8s-1.31,13.16-1.77,17.79c-.21,2.22-.38,4-.5,5.39l-.15,1.47a1.85,1.85,0,0,1-.09.51,1.61,1.61,0,0,1,0-.52c0-.4,0-.88,0-1.47,0-1.28.17-3.13.33-5.41.33-4.57.91-10.86,1.62-17.81s1.31-13.16,1.77-17.78c.21-2.22.38-4,.5-5.4.07-.58.12-1.07.16-1.46A1.74,1.74,0,0,1,119.58,282.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.96,
    y: 309.09,
    width: 2.03,
    height: 3.78,
    transform: "translate(-5.31 1.47) rotate(-0.98)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.87,282.51a3.22,3.22,0,0,1-.68,0h-2l-7.19-.1-23.69-.55-23.69-.71-7.18-.28-2-.1a3.1,3.1,0,0,1-.67-.07,3.22,3.22,0,0,1,.68,0h2l7.18.11,23.7.55,23.69.71,7.18.28,2,.1A3.1,3.1,0,0,1,119.87,282.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6,253.93S78.14,266.28,78,268.24s-2.12,5.09.13,5.82c0,0-.38,1.52,2,2.07,0,0,0,2.59,3.14,2.31,0,0,2.15,2.11,3.92,1,0,0,2.74,1.36,3.86-.64a42.28,42.28,0,0,0,2.26-5.16l1.78,1.4a7.68,7.68,0,0,0,.53-4.56c-.52-2.4-3.56-5.44-2.88-8.44a13.63,13.63,0,0,1,.91-3.15Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.09,299.43a38,38,0,0,1-11.61,15.11c-3.59,2.9-8.06,5.21-12.65,4.73-4-.42-7.52-2.9-10.44-5.69A46.29,46.29,0,0,1,58.87,293s11,18.16,24.09,17.91C94.76,310.63,106.09,299.43,106.09,299.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M152.34,138s17.91,3.7,20.12,6.41c1.77,2.16,11.17,24.07,11.17,24.07l7.58,13.44a10.27,10.27,0,0,1,3.36,5,61.32,61.32,0,0,1,1.36,13.41s-1.35,8.84-6.88,9.21a19.71,19.71,0,0,1-14.24-5.28c-3.23-2.89-11.13-22.48-10.85-23.48Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.53,134l.78-.9,8.16,9.24,6.55,7.17h0l8.21-17.36,2.38,1.75s8.84,66.91,8.69,67.69,3.42,37.3,3.42,37.3-18.81,3.74-24.26,2-17.57,1-17.49.44-5.2-22.92-5.2-22.92l1.55-61.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.53,230.71a8,8,0,0,1-1.36-.31c-.86-.23-2.1-.6-3.62-1.12a83.83,83.83,0,0,1-11.5-4.89,85.19,85.19,0,0,1-10.65-6.54c-1.3-.94-2.33-1.73-3-2.3a7.1,7.1,0,0,1-1-.93,8.71,8.71,0,0,1,1.16.77c.72.52,1.78,1.27,3.09,2.17a106.1,106.1,0,0,0,10.69,6.37,101.69,101.69,0,0,0,11.39,5c1.49.55,2.71,1,3.55,1.27A7.53,7.53,0,0,1,154.53,230.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,149.51a3.69,3.69,0,0,1,0,.76c0,.54,0,1.27,0,2.17,0,1.95,0,4.67-.06,8,0,6.76-.05,16.1.08,26.41s.38,19.66.58,26.41c.1,3.34.18,6.06.24,8,0,.9,0,1.63,0,2.17a3.4,3.4,0,0,1,0,.76,4.52,4.52,0,0,1-.08-.75c0-.55-.09-1.27-.14-2.18-.12-1.88-.25-4.62-.4-8-.29-6.76-.6-16.1-.74-26.42s-.06-19.66.08-26.42c.07-3.38.14-6.12.22-8,0-.91.07-1.63.09-2.18A4.07,4.07,0,0,1,135,149.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.17,238.51a49,49,0,0,1-.47-7,48.59,48.59,0,0,1,0-7,49,49,0,0,1,.47,7A48.59,48.59,0,0,1,139.17,238.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05,134.83,113,141.45s-7.63,1.86-16.25,4.73a12.4,12.4,0,0,0-7.19,8.09c-.65,2.19,10.34,55.25,10.34,55.25L98,224.8l-5.86,44.07s10.16,3.62,16.68,3.88c3.67.15,4.28-14.22,5.83-24.18,1.49-9.62,5.35-40.42,5.35-49s-1.79-49.93-1.79-50.82S119.05,134.83,119.05,134.83Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.82,212.39a4.8,4.8,0,0,1-.24-.79c-.15-.57-.34-1.32-.59-2.27-.5-2-1.21-4.89-2.07-8.39-1.71-7.14-4-16.92-6.64-27.72-.72-3.07-1.43-6.05-2.1-8.91l0-.08,0-.07,5-12.36.19.29-4.91,0h-.33l.17-.28c2-3.41,3.65-6.18,4.82-8.15l1.33-2.2a5,5,0,0,1,.5-.75,7.41,7.41,0,0,1-.41.81l-1.25,2.25c-1.12,2-2.71,4.79-4.66,8.23l-.17-.28,4.91,0h.32l-.12.3c-1.45,3.7-3.1,7.88-4.87,12.39v-.15c.68,2.85,1.38,5.83,2.11,8.9l6.49,27.75c.8,3.52,1.45,6.39,1.91,8.43.21,1,.38,1.73.5,2.3A5.55,5.55,0,0,1,118.82,212.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.57,133.63l3.88,3.53,22.25,6.3L172,179l-3.32,35.63,6.81,53.19c-7.72,4.25-19.24,3.34-19.24,3.34l-5.29-31.08c-.83-5.8-3.72-44.89-3.72-44.89Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.57,205.82a4.15,4.15,0,0,1,.08-.79c.09-.55.2-1.3.34-2.23.31-2,.74-4.77,1.27-8.19,1-6.92,2.39-16.5,3.58-27.11.59-5.31,1.09-10.37,1.51-15,.2-2.3.38-4.49.56-6.55.08-1,.24-2.06-.32-2.72a2.5,2.5,0,0,0-2.39-.47,10.3,10.3,0,0,1-2.51.29,4.66,4.66,0,0,1-2.15-.73,9.46,9.46,0,0,1-2.52-2.57c-.56-.81-1-1.46-1.2-1.91a3.79,3.79,0,0,1-.37-.7,5.58,5.58,0,0,1,.45.65c.29.42.7,1.06,1.28,1.84a9.45,9.45,0,0,0,2.51,2.44,4.39,4.39,0,0,0,2,.65,9.85,9.85,0,0,0,2.43-.32,5.28,5.28,0,0,1,1.39-.09,2,2,0,0,1,1.36.66,2.3,2.3,0,0,1,.51,1.48,13.22,13.22,0,0,1-.06,1.54c-.17,2.05-.34,4.25-.52,6.55-.39,4.62-.88,9.69-1.47,15-1.19,10.62-2.6,20.2-3.73,27.11-.58,3.45-1.07,6.24-1.43,8.17-.18.92-.33,1.66-.44,2.21A4.17,4.17,0,0,1,153.57,205.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.63,168.35a12.64,12.64,0,0,1-3.66.32,13.06,13.06,0,0,1-3.67-.2,13.48,13.48,0,0,1,3.67-.31A13.16,13.16,0,0,1,168.63,168.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.6,187a10.36,10.36,0,0,1,6.09-3.9c.59-.12,1.37-.1,1.6.45a1.26,1.26,0,0,1-.41,1.27l-.75.91a13.6,13.6,0,0,0-4.16,8.38,7.39,7.39,0,0,1,2.71-8.16c-2.38.48-4.19,2.35-5.84,4.13A3.28,3.28,0,0,1,172.6,187Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M170.92,190.92s.28-.44.79-1.09a11.48,11.48,0,0,1,2.3-2.26,11.85,11.85,0,0,1,2.84-1.53c.78-.28,1.28-.39,1.28-.43s-.14,0-.37,0a8.8,8.8,0,0,0-1,.24,10.32,10.32,0,0,0-5.22,3.84,8.58,8.58,0,0,0-.52.85C171,190.79,170.9,190.91,170.92,190.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.27,196.21s0-.7,0-1.82a14.34,14.34,0,0,1,.25-1.94,16.88,16.88,0,0,1,.68-2.31,16,16,0,0,1,1.08-2.15,14.94,14.94,0,0,1,1.14-1.6c.71-.86,1.24-1.31,1.22-1.35a2.2,2.2,0,0,0-.39.31c-.12.1-.27.23-.43.39s-.34.33-.52.55a12.85,12.85,0,0,0-1.2,1.59,14.78,14.78,0,0,0-1.1,2.18,13.88,13.88,0,0,0-.68,2.35,12.86,12.86,0,0,0-.21,2,6.24,6.24,0,0,0,0,.76,4.52,4.52,0,0,0,0,.58A2,2,0,0,0,175.27,196.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.68,157.88a1.8,1.8,0,0,1,0,.55c0,.43,0,.95,0,1.59-.06,1.46-.14,3.44-.24,5.85-.26,5-.61,11.78-1,19.28s-.86,14.27-1.16,19.27c-.17,2.4-.3,4.38-.41,5.83,0,.64-.1,1.17-.13,1.59a2.08,2.08,0,0,1-.09.55,3.64,3.64,0,0,1,0-.56c0-.42,0-1,0-1.59.06-1.46.15-3.44.25-5.85.26-5,.61-11.78,1-19.28s.85-14.26,1.15-19.26c.17-2.41.31-4.38.41-5.84.06-.64.1-1.16.14-1.58A2.47,2.47,0,0,1,171.68,157.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.38,147.51s-5.06,1.87-6.44,9.58-10,102.06-10,102.06l14.58.84,7.17-51.35Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.69,209.72c.15,0-1.45,12-3.57,26.79s-4,26.73-4.09,26.7,1.46-12,3.57-26.78S100.55,209.7,100.69,209.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.73,164.77c.15,0,1.15,10,2.24,22.45s1.87,22.49,1.72,22.51-1.14-10-2.24-22.46S96.59,164.78,96.73,164.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,150a7.32,7.32,0,0,1-1.08-.88l-2.81-2.54.31-.08c-.9,2.57-2.15,6-3.54,9.77l-.16.44-.29-.36-.2-.26a49.4,49.4,0,0,1-6-9.51c-.63-1.3-1.08-2.38-1.36-3.13a5.68,5.68,0,0,1-.38-1.2,6.86,6.86,0,0,1,.57,1.12c.34.73.83,1.77,1.5,3a56.91,56.91,0,0,0,6.1,9.36l.2.25-.45.07c1.4-3.77,2.69-7.18,3.67-9.72l.11-.27.2.2,2.69,2.66A6.29,6.29,0,0,1,135,150Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.73,139.81a4.81,4.81,0,0,1,0,1.18c-.08.86-.18,1.93-.3,3.19-.28,2.7-.71,6.42-1.2,10.53l0,.32-.09.67-.39-.56c-2.34-3.36-4.42-6.41-5.89-8.6l.28,0-2.19,2.19a5.43,5.43,0,0,1-.85.76,4.51,4.51,0,0,1,.71-.89l2.07-2.31.15-.16.13.18c1.55,2.14,3.68,5.15,6,8.52l-.47.11,0-.31c.5-4.11,1-7.82,1.35-10.51.19-1.26.34-2.32.47-3.18A5.25,5.25,0,0,1,145.73,139.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.76,252s.19-.06.52,0a1.93,1.93,0,0,1,1.12.88,2.69,2.69,0,0,1,.34.94,2,2,0,0,1-.18,1.18,2.46,2.46,0,0,1-2.21,1.39,2.23,2.23,0,0,1-1.86-1.81,2.17,2.17,0,0,1,.6-2,2.1,2.1,0,0,1,1.26-.64c.34,0,.52,0,.51.07a2.67,2.67,0,0,0-1.5.82,1.88,1.88,0,0,0-.41,1.68,1.81,1.81,0,0,0,1.45,1.39,2,2,0,0,0,1.73-1.09,1.88,1.88,0,0,0,0-1.72C91.57,252.1,90.72,252.08,90.76,252Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.63,233.41s-13.35,1-12.77.79l3.84,7.24,12.44-.88Z",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.63,233.41a2.7,2.7,0,0,1,.28.46l.74,1.39c.68,1.32,1.59,3.08,2.68,5.21l.13.27-.3,0-12.44.94h-.17l-.08-.15-.14-.26c-1.3-2.48-2.55-4.83-3.69-7l.29.12,0,0h0s.1,0,.07-.26-.16-.13-.14-.14h.58l.68,0,1.33-.07,2.46-.13,4.06-.22,2.64-.12a6.36,6.36,0,0,1,.95,0,4.12,4.12,0,0,1-.94.15l-2.63.25-4.05.33-2.47.18-1.33.09-.68,0-.36,0h-.41s0,.05-.15-.16.1-.26.07-.26l0,0,.07,0,.19-.06.1.18,3.72,7,.14.27-.25-.14,12.45-.83-.17.3-2.45-5.21-.67-1.47A2.79,2.79,0,0,1,170.63,233.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.39 235.12 97.29 233.41 94.73 241.44 107.09 243.23 109.39 235.12",
    style: {
      fill: "#FF81AE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.39,235.12a2.27,2.27,0,0,1-.11.54l-.4,1.62c-.36,1.41-.89,3.48-1.59,6l0,.17-.19,0-12.23-1.72-.14,0-.3,0,.09-.3c.92-2.86,1.8-5.57,2.59-8l.06-.19.19,0c3.63.53,6.68,1,8.8,1.36l2.45.41a4.32,4.32,0,0,1,.82.17s-.35,0-1-.08l-2.52-.29c-2.14-.26-5.14-.62-8.66-1.1l.26-.16c-.78,2.44-1.64,5.16-2.54,8l-.21-.34.14,0L107.12,243l-.23.15c.71-2.41,1.33-4.4,1.77-5.81.2-.65.37-1.19.52-1.64A3.86,3.86,0,0,1,109.39,235.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.59,154a1.87,1.87,0,0,1,.93,1.16,1.73,1.73,0,0,1-.13,1.14l-5.51,12.27-3.59,7.22-10.6-2.56,6.85-17.1s.56-2.36,2.72-2.36h8.42A1.81,1.81,0,0,1,193.59,154Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.19,157.09h1.38a.57.57,0,0,0,.49-.3h0a.55.55,0,0,0-.49-.81h-1.38a.55.55,0,0,0-.5.32h0A.56.56,0,0,0,191.19,157.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,188.2c.38-.8-1-2-1-2s-1.68-8.11-1-9.49.34-3.08.46-5.94,1.16-3.88,1.16-3.88.09-1.83.32-3.31a3.67,3.67,0,0,0-.68-2.63l-3.36,7.66-.55-.69a22.55,22.55,0,0,0-5.46-5.7c-1.08-.58-1.9.5-2.21,1.34s.93,2.3,1.7,2.83,2,3.93,2.45,5.17,0,1.51-.78,2-3.75-2-5.19-2.59a14.14,14.14,0,0,1-3.45-2.71,1.86,1.86,0,0,0-1.93-.2c-1.13.51-.62,2.71-.62,2.71-1.79,1.36-.86,4-.86,4s-1.79.14-1.91.74.49,3.82,1.49,4.6,5.28,3.78,5.28,3.78a9.51,9.51,0,0,0,3.86,3.36l.84,4.21a10,10,0,0,0,5.62,0A14,14,0,0,0,193,188.2Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.87,170.52s0,0,0,.11a1.21,1.21,0,0,0,0,.31,2.54,2.54,0,0,0,.44,1.06,5.37,5.37,0,0,0,1.19,1.2c.51.38,1.09.75,1.72,1.13a25.31,25.31,0,0,0,3.34,1.65c.44.17.81.3,1.06.38l.4.11s-.54-.24-1.4-.63a31.16,31.16,0,0,1-3.3-1.7,9.64,9.64,0,0,1-2.89-2.23A2.83,2.83,0,0,1,172.87,170.52Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.07,174.78a4.44,4.44,0,0,0,.74.91A12.59,12.59,0,0,0,175,177.5a12.12,12.12,0,0,0,2.55,1.26,4.48,4.48,0,0,0,1.14.31s-.42-.17-1.08-.45a14.76,14.76,0,0,1-2.49-1.3,15.36,15.36,0,0,1-2.2-1.73C172.39,175.09,172.09,174.76,172.07,174.78Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.38,174.82a1.38,1.38,0,0,0,.5-.83,5.85,5.85,0,0,0-.06-2.34,18,18,0,0,0-.5-2.28,3.75,3.75,0,0,0-.33-.91,5.5,5.5,0,0,0,.19.95c.13.58.3,1.38.44,2.27a6.8,6.8,0,0,1,.11,2.28A3.34,3.34,0,0,1,189.38,174.82Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.14,178.4s.13,0,.34,0a1.17,1.17,0,0,0,.64-.52,1.2,1.2,0,0,0,.14-.81c0-.21-.13-.32-.16-.3a1.86,1.86,0,0,1-.16,1C185.64,178.26,185.12,178.34,185.14,178.4Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.59,181.6s.16.08.43,0a1.56,1.56,0,0,0,.92-.48,1.53,1.53,0,0,0,.41-.95c0-.27,0-.43-.07-.42s0,.16-.07.4a1.86,1.86,0,0,1-.42.83,1.91,1.91,0,0,1-.8.48A2,2,0,0,0,181.59,181.6Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.51,183.5s.13.06.34,0a1.38,1.38,0,0,0,.68-.48,1.31,1.31,0,0,0,.27-.79c0-.22-.07-.34-.09-.33a2.33,2.33,0,0,1-.35,1A2.26,2.26,0,0,1,178.51,183.5Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74,187.44a2.28,2.28,0,0,0,.73.32,14.24,14.24,0,0,0,1.87.48,14.87,14.87,0,0,0,1.91.21,2.6,2.6,0,0,0,.8,0c0-.06-1.21-.11-2.67-.38S180.76,187.38,180.74,187.44Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44,170.21l.11-.25.28-.74,1-2.74c.85-2.34,2-5.54,3.26-9.06a4.15,4.15,0,0,1,1.47-2.18,4.56,4.56,0,0,1,2.43-.43l4.33.05,2.92,0H194a.9.9,0,0,0,.28,0l-.28,0-.79,0-2.92-.08-4.33-.09a8.94,8.94,0,0,0-1.26,0,3,3,0,0,0-1.27.42,4.27,4.27,0,0,0-1.57,2.27c-1.26,3.55-2.39,6.76-3.2,9.09l-.94,2.76c-.11.31-.19.56-.25.75A.85.85,0,0,0,177.44,170.21Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.46,472.43c0,.14-92,.26-205.45.26s-205.47-.12-205.47-.26,92-.27,205.47-.27S450.46,472.28,450.46,472.43Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationImage);
export default __webpack_public_path__ + "static/media/locationImage.5fde7446093357030c914e3118013604.svg";
export { ForwardRef as ReactComponent };